export type TipoCampoCadastro =
  | "text" | "number" | "doc" | "email" | "phone" | "list"
  | "boolean" | "date" | "multiple" | "unique";

export type CampoCadastro = {
  nome: string;
  tipo: TipoCampoCadastro;
  obrigatorio: boolean;
  identificador: boolean;
  opcoes: string[];
};

export type CadastroModelo = {
  id?: string;
  empresa: string;
  nome: string;
  campos: CampoCadastro[];
  dataCriacao?: number;
  dataAlteracao?: number;
  dataInativacao?: number;
};

export const TIPOS_IDENTIFICADOR: TipoCampoCadastro[] = ["text", "number", "email", "phone", "doc", "unique"];
